import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import MedalliaActions, { MedalliaRedux, MedalliaTypes } from '../Redux/MedalliaRedux'
import { notificationSuccess, notificationFail } from '../Redux/NotificationActions'

const MedalliaCRUDObservable = createCRUDObservable({
  mainRedux: MedalliaRedux,
  reduxPath: 'medallia',
})

const medalliaReportEpic = (action$, store, { Api }) =>
  action$.ofType(MedalliaTypes.MedalliaRequest)
    .mergeMap(({ start_date, end_date, type_quiz }) => (
      Observable
        .fromPromise(Api.medallia.getMedalliaExcel(start_date, end_date,type_quiz)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const { data } = response
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            MedalliaActions.MedalliaSuccess(data, fileName),
          ]
        })
    ))

const centersMedalliaEpic = (action$, store, { Api }) =>
  action$.ofType(MedalliaTypes.CentersMedalliaRequest)
    .mergeMap(({ start_date, end_date, centerId }) => (
      Observable
        .fromPromise(Api.medallia.getCentersMedalliaExcel(start_date, end_date, centerId)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const { data } = response
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            MedalliaActions.CentersMedalliaSuccess(data, fileName),
          ]
        })
    ))

export const MedalliaObservers = Object.assign({}, MedalliaCRUDObservable.observers, {})
export const medalliaEpic = combineEpics(
  MedalliaCRUDObservable.epic,
  medalliaReportEpic,
  centersMedalliaEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/MedalliaObservable.js